module.exports = __webpack_public_path__ + "img/linepay.d09a36e1.png";